const requests = {
  fetchEmployees: "/employees/fetch",
  passwordrecovery: "/employee/updatepassword",
  loginuser: "/login/user",
  fetchDepartments: "/departments/count",
  employeesadd: "/employees/register",
  updateinfo: "/employees/update",
  deleteuser: "/employee/delete",
  gettimestamp: "/employee/timestamps",
  updatetimestamp: "/employee/timestamps/update",
  gettimerecord: "/employee/timerecord",
  updatetimerecord: "/employee/timerecord/update",
  getsalary: "/employee/fetch/salary",
  gettotalhours: "/employee/fetch/totalhours",
  getavaragetime: "/employee/fetch/avaragetime",
};

export { requests };
